import { render, staticRenderFns } from "./EarlyWorks.vue?vue&type=template&id=2f96e21c&scoped=true"
import script from "./EarlyWorks.vue?vue&type=script&lang=js"
export * from "./EarlyWorks.vue?vue&type=script&lang=js"
import style0 from "./EarlyWorks.vue?vue&type=style&index=0&id=2f96e21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96e21c",
  null
  
)

export default component.exports